export function dataInRequest(params = {}) {
    return {
      type: '@padroes/DATA_IN_REQUEST',
      payload: { params },
    };
  }
  
  export function findData(id) {
    return {
      type: '@padroes/FIND_DATA',
      payload: { id },
    };
  }
  
  export function failedRequest() {
    return {
      type: '@padroes/FAILED_REQUEST',
    };
  }
  
  export function deleteData(id, params) {
    return {
      type: '@padroes/DELETE_DATA',
      payload: { id, params },
    };
  }
  
  export function updateData(data, params) {
    return {
      type: '@padroes/UPDATE_DATA',
      payload: { data, params },
    };
  }
  
  export function storeData(data, params) {
    return {
      type: '@padroes/STORE_DATA',
      payload: { data, params },
    };
  }
  
  export function successInRequest(data, page, pageSize, totalCount, totalPages) {
    return {
      type: '@padroes/SUCCESS_IN_REQUEST',
      payload: { data, page, pageSize, totalCount, totalPages },
    };
  }
  
  export function successRequest(data) {
    return {
      type: '@padroes/SUCCESS_REQUEST',
      payload: { data },
    };
  }
  
  export function successRemove(params) {
    return {
      type: '@padroes/SUCCESS_REMOVE',
      payload: { params },
    };
  }
  
  export function recordFiltering(params) {
    return {
      type: '@padroes/RECORD_FILTERING',
      payload: { params },
    };
  }
  